import React, { FC, useState } from 'react';
import { SignInBox } from './SignInBox';
import { SignInProps } from './SignIn.types';
import { SignInModalForm } from './SignInModalForm';

const SignIn: FC<SignInProps> = ({ isSignedIn, propertyId, signIn }) => {
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleSignInModalOpen = () => {
    setIsSignInModalOpen(true);
  };

  const handleSignInModalClose = () => {
    setIsSignInModalOpen(false);
  };

  const handleSignIn = async (data) => {
    try {
      await signIn(propertyId, data);
      setIsSignInModalOpen(false);
    } catch (e) {
      setLoginError('invalid login');
    }
  };

  return (
    <>
      <SignInBox isSignedIn={isSignedIn} handleModalOpen={handleSignInModalOpen} />
      <SignInModalForm
        isModalOpen={isSignInModalOpen}
        handleModalClose={handleSignInModalClose}
        onSubmit={handleSignIn}
        loginError={loginError}
      />
    </>
  );
};

export default SignIn;
